<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("businessPage.tabRegistered") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <RegisteredHotels />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("businessPage.tabPending") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <PendingHotels />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="3" ripple> {{ $t("businessPage.tabBusinesses") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <BusinessAccounts :manage="true" />
        </div>
      </v-tab-item>
    </v-tabs>


  </div>
</template>

<script>

import RegisteredHotels from "@/views/passengers/RegisteredHotels";
import PendingHotels from "@/views/passengers/PendingHotels";
import BusinessAccounts from "@/views/business_accounts/BusinessAccounts";

export default {
  name: "Business Accounts Tabs",
  title: "businessPage.pageTitle",
  components: {
    RegisteredHotels,
    PendingHotels,
    BusinessAccounts
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {
    // Deep-link to the Pending tab (e.g. from the toolbar notifications bell).
    if (this.$route.query && this.$route.query.tab === "pending") {
      this.active = 1;
    }
  },
};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
